import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@saviynt/design-system';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { NODE_DATA_MODEL } from '../../../../models/CertsModels';
import CertsActionButtonsGroup from '../../../CertsActionButtons/CertsActionButtonsGroup/CertsActionButtonsGroup';
import { ACTION_BUTTON_GROUP_KINDS } from '../../../CertsActionButtons/constant';
import { getLoadingFlag } from '../../../CertsDetailsList/Tile/utils';

import './CertsSidePanelFooter.css';

function CertsSidePanelFooter({
  nodeData,
  actionsData,
  handleAutoSelectParent,
  setMergedLists,
  isMobileMode,
  dataTestId,
  className,
}) {
  const {
    bulkAction: {
      isChecked,
      isAtleastOneSelected,
      isChecked: isBulkChecked,
      isDisabled: isBulkDisabled,
      isSubmittingAction,
    },
  } = useSelector((state) => state?.certifications?.details);

  const shouldDisableWhileCallingActionApis = getLoadingFlag(
    nodeData?.tracker?.actions
  );

  const sidePanelFooterClasses = classnames('CertsSidePanelFooter', className);
  const checkForActions =
    nodeData?.availableAction &&
    Object.keys(nodeData?.availableAction).length > 0;

  const isSaviResponded = Boolean(
    nodeData?.savi_responded && nodeData?.savi_responded === '1'
  );

  const saviRespondedReason = [];

  if (
    isSaviResponded &&
    nodeData?.savi_reason &&
    nodeData?.savi_reason.length > 0
  ) {
    nodeData?.savi_reason.map((item) => saviRespondedReason.push(item));
  }

  const getGroupTooltipText = () => {
    if (isMobileMode) {
      return 'Options for multiple-item selections are available in the toolbar behind.';
    }

    return 'Options for multiple-item selections are available in the toolbar on left.';
  };

  const shouldDisableActionBtns = Boolean(
    isAtleastOneSelected ||
      isBulkChecked ||
      isBulkDisabled ||
      isSubmittingAction ||
      shouldDisableWhileCallingActionApis
  );

  return (
    <Box
      tag='section'
      className={sidePanelFooterClasses}
      data-testid={dataTestId}>
      {checkForActions && (
        <CertsActionButtonsGroup
          kind={ACTION_BUTTON_GROUP_KINDS.FOOTER}
          nodeData={nodeData || {}}
          actionsData={actionsData}
          handleAutoSelectParent={handleAutoSelectParent}
          setMergedLists={setMergedLists}
          groupTooltipText={
            isAtleastOneSelected || isChecked ? getGroupTooltipText() : null
          }
          isGroupDisabled={
            isAtleastOneSelected || isChecked || shouldDisableActionBtns
          }
          isSaviResponded={isSaviResponded}
          saviRespondedReason={saviRespondedReason}
        />
      )}
    </Box>
  );
}

CertsSidePanelFooter.propTypes = {
  nodeData: PropTypes.shape(NODE_DATA_MODEL),
  actionsData: PropTypes.shape(NODE_DATA_MODEL),
  handleAutoSelectParent: PropTypes.func.isRequired,
  setMergedLists: PropTypes.func.isRequired,
  isMobileMode: PropTypes.bool,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
};

CertsSidePanelFooter.defaultProps = {
  nodeData: null,
  actionsData: null,
  isMobileMode: false,
  className: null,
  dataTestId: null,
};

export default CertsSidePanelFooter;
